var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 29,
    viewBox: "0 0 37 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M18.5 3.625C12.1211 3.625 6.95 7.91685 6.95 13.2111C6.95 13.2686 6.95061 13.326 6.95183 13.3833C4.10427 13.9909 2 16.1359 2 18.6889C2 21.7142 4.95492 24.1667 8.6 24.1667H26.75C31.3063 24.1667 35 21.1011 35 17.3194C35 14.4071 32.8093 11.9194 29.7209 10.9296C28.4876 6.73682 23.9316 3.625 18.5 3.625Z",
    fill: "#800000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 4.375C12.3984 4.375 7.7 8.45584 7.7 13.2111C7.7 13.2633 7.70055 13.3154 7.70166 13.3674C7.70929 13.7272 7.46029 14.0417 7.10833 14.1168C4.50425 14.6724 2.75 16.5851 2.75 18.6889C2.75 21.1752 5.23223 23.4167 8.6 23.4167H26.75C31.029 23.4167 34.25 20.5621 34.25 17.3194C34.25 14.8146 32.3552 12.5615 29.492 11.6438C29.2553 11.568 29.0715 11.3797 29.0014 11.1413C27.8818 7.33531 23.6752 4.375 18.5 4.375ZM6.2095 12.7974C6.46888 7.16634 12.002 2.875 18.5 2.875C24.0313 2.875 28.8225 5.96103 30.321 10.3426C33.4473 11.4835 35.75 14.1247 35.75 17.3194C35.75 21.64 31.5837 24.9167 26.75 24.9167H8.6C4.67761 24.9167 1.25 22.2532 1.25 18.6889C1.25 15.8791 3.39987 13.6165 6.2095 12.7974Z",
    fill: "#800000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoam);
export default "/Frontend/static/media/foam.aacff7b88a62786d74015b8cbcdfe883.svg";
export { ForwardRef as ReactComponent };